import React from 'react'
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import Close from '@material-ui/icons/Close';

import TwoPointThreeSubHeader from '../../formV2/excel/two-point-three-header/index'
import ExcelSubHeader from '../../formV2/excel/sub-header'
import SubLabelType1 from '../../formV2/excel/sub-label-1'
import SubLabelType2 from '../../formV2/excel/sub-label-2'
import SubLabelType3 from '../../formV2/excel/sub-label-3'

export default function FastEditModal({
    open,
    onClose,
    question,
    answers,
    onFillForm,
    formType,
    flags
}) {
    if (!question) return null

    const sub_label_type = (question.subLabel_2 && question.subLabel_1) ? 3 : question.subLabel_1 ? 2 : 1
    const isTwoPointThree = question.no.includes('2.3.') || question.no.includes('2.2.')

    // Find the specific item ID we are editing. 
    // Usually 'question' is the whole detail object.
    // If it's Type 1, there's only one record.
    // If Type 2/3, we need to match the specific sub-label if possible, or render all.
    // CURRENTLY: The modal is triggered by 'activeItem' which maps to 'question.id'.
    // However, question.id usually comes from the 'detail' object itself or one of its records.

    // Strategy: Render the relevant row(s).
    // For Type 2/3, 'question' is the full detail. We should render the sub-labels.
    // BUT we want to highlight or show only the invalid one?
    // The user request implies they want the "model" (layout) to look like the web form.
    // So showing the whole block for that question (all sub-rows) is safest and most consistent.

    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <DialogTitle>
                <Grid container justifyContent="space-between" alignItems="center">
                    <Grid item>
                        <Typography variant="h6">แก้ไขข้อมูล: {question.no}</Typography>
                    </Grid>
                    <Grid item>
                        <IconButton onClick={onClose}><Close /></IconButton>
                    </Grid>
                </Grid>
            </DialogTitle>
            <DialogContent dividers>
                <Typography gutterBottom variant="body1" className="font-bold">{question.label}</Typography>

                <Grid container spacing={2} className="mt-2 mb-4">
                    <Grid item xs={12} sm={6}>
                        <Typography variant="body2" style={{ fontWeight: 'bold' }}>ค่าเป้าหมาย</Typography>
                        <Typography variant="body2">{question.targeted_text || '-'}</Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Typography variant="body2" className="text-red-500" style={{ fontWeight: 'bold' }}>เงื่อนไขการกรอกข้อมูล</Typography>
                        <Typography variant="body2" className="text-red-500">{question.filling_condition || '-'}</Typography>
                    </Grid>
                </Grid>

                <Grid className="col-span-12 grid grid-cols-12 my-5 rounded-md border p-4">
                    {/* Header */}
                    <Grid
                        className="col-span-12 text-center border p-1 font-bold"
                        style={{ backgroundColor: '#C8E8FF' }}>
                        ผลการวัด
                    </Grid>

                    {/* Two Point Three Sub Header */}
                    {isTwoPointThree && (
                        <TwoPointThreeSubHeader sub_label_type={sub_label_type} />
                    )}

                    {/* Sub Header */}
                    <ExcelSubHeader
                        sub_label_type={sub_label_type}
                        isTwoPointThree={isTwoPointThree}
                    />

                    {/* Content */}
                    {/* Sub Label Type 1 */}
                    {sub_label_type === 1 && (
                        <SubLabelType1
                            type={formType}
                            datasetId={question.id}
                            onFillForm={onFillForm}
                            answers={answers}
                            validationRules={{
                                dataType: question.data_type,
                                condition: question.filling_condition,
                                targetValue: question.targetValue,
                                targetCondition: question.targetCondition
                            }}
                        />
                    )}

                    {/* Sub Label Type 2 */}
                    {sub_label_type === 2 && (
                        <SubLabelType2
                            key={'type_2'}
                            flags={flags || {}}
                            item={{ id: question.id, label: question.subLabel_1 }}
                            preField={{}}
                            type={formType}
                            onFillForm={onFillForm}
                            answers={answers}
                            validationRules={{
                                dataType: question.data_type,
                                condition: question.filling_condition,
                                targetValue: question.targetValue,
                                targetCondition: question.targetCondition
                            }}
                        />
                    )}

                    {/* Sub Label Type 3 */}
                    {sub_label_type === 3 && (
                        <SubLabelType3
                            key={`${question.subLabel_1}-${question.label}-${question.no}`}
                            item={{
                                label_name: question.subLabel_1,
                                childs: [{ id: question.id, label: question.subLabel_2 }]
                            }}
                            preField={{}}
                            type={formType}
                            onFillForm={onFillForm}
                            answers={answers}
                            validationRules={{
                                dataType: question.data_type,
                                condition: question.filling_condition,
                                targetValue: question.targetValue,
                                targetCondition: question.targetCondition
                            }}
                        />
                    )}
                </Grid>

                <Typography variant="caption" color="textSecondary">
                    * การแก้ไขข้อมูลในหน้านี้จะมีผลทันที แต่ค่าอาจจะยังทำการตรวจสอบข้อมูลอีกครั้ง (Next/Submit) เพื่อให้สถานะข้อผิดพลาดอัปเดต
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="primary" variant="contained">ปิดหน้าต่าง</Button>
            </DialogActions>
        </Dialog>
    )
}
